import { render, staticRenderFns } from "./TestimoniosListado.vue?vue&type=template&id=5fe9cfd8"
import script from "./TestimoniosListado.vue?vue&type=script&lang=js"
export * from "./TestimoniosListado.vue?vue&type=script&lang=js"
import style0 from "./TestimoniosListado.vue?vue&type=style&index=0&id=5fe9cfd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports